import { render, staticRenderFns } from "./EditTechnician.vue?vue&type=template&id=7ffd4b0a&"
import script from "./EditTechnician.vue?vue&type=script&lang=js&"
export * from "./EditTechnician.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports